module.exports = __webpack_public_path__ + "static/cycymymy-fe587d500ca63626265016ec8a9fe1a4.png";